import { useQuery } from '@tanstack/react-query';

import { IDashboardResponse } from 'models/dashboard/i-dashboard.interface';

import { fetchDashboardData } from 'services/dashboard.service';

import { queryKeys } from './query-keys';

export interface UseDashboardQueryReturn {
  data: IDashboardResponse | null;
  loading: boolean;
  error: string | null;
  refetch: () => void;
}

const getDashboardData = async (): Promise<IDashboardResponse> => {
  const response = await fetchDashboardData();
  return response.data;
};

export const useDashboardQuery = (): UseDashboardQueryReturn => {
  const {
    data = null,
    isLoading,
    error,
    refetch,
  } = useQuery({
    queryKey: queryKeys.dashboard.market(),
    queryFn: getDashboardData,
    staleTime: 30_000,
    refetchInterval: 30_000,
    retry: 1,
  });

  return {
    data,
    loading: isLoading,
    error: error ? (error instanceof Error ? error.message : 'Failed to fetch dashboard data') : null,
    refetch,
  };
};
